import { Stack, FormControlLabel, Switch } from '@mui/material';
import { useFormikContext } from 'formik';

const Config = () => {
  const { values, handleChange } = useFormikContext<{
    isPublished: boolean;
    isPrivate: boolean;
  }>();

  return (
    <Stack gap={2} flex={1}>
      <Stack flexDirection={'row'}>
        <FormControlLabel
          control={
            <Switch
              name="isPublished"
              checked={values.isPublished}
              onChange={handleChange}
            />
          }
          label="Publicado"
        />
        <FormControlLabel
          control={
            <Switch
              name="isPrivate"
              checked={values.isPrivate}
              onChange={handleChange}
            />
          }
          label="Privado"
        />
      </Stack>
    </Stack>
  );
};

export default Config;
